<template>
  <div class="page-container">
    <div class="content">
      <h1>
        进入PP视频
        <span class="dot dot-active"></span>
      </h1>
      <LoginInput :phone.sync="phone" @validate="phoneValidate = $event" />
      <CodeInput
        :code.sync="code"
        :phone="phone"
        :active.sync="phoneValidate"
        @validate="codeValidate = $event"
      />
      <div class="button" @click="handleLogin">
        登录
      </div>
    </div>
    <div class="footer">
      <p>登录即代表阅读并同意</p>
      <p class="read" @click="navigateTo">【PP视频用户协议】</p>
    </div>
  </div>
</template>

<script>
import LoginInput from "@/views/login/components/PhoneInput";
import CodeInput from "@/views/login/components/CodeInput";
import { authLogin } from "@/api/login";
import { setToken } from "@/utils/auth";
import { mapState, mapActions } from "vuex";

export default {
  name: "Login",
  components: {
    LoginInput,
    CodeInput
  },
  computed: {
    ...mapState("user", ["id"])
  },
  data() {
    return {
      active: false,
      phone: "",
      code: "",
      phoneValidate: false,
      codeValidate: false
    };
  },
  methods: {
    ...mapActions("user", ["login"]),
    handleLogin() {
      if (this.phoneValidate && this.codeValidate) {
        this.login({ username: this.phone, code: this.code });
      } else {
        this.$toast("输入格式有误");
      }
    },
    navigateTo() {
      this.$router.push({ name: "userProtocol" });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  height: 100vh;
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    h1 {
      position: relative;
      margin: 80px 0 37px 0;
      font-size: 22px;
      font-weight: 500;
      color: rgba(29, 25, 24, 1);
      line-height: 30px;
      text-align: left;
      .dot {
        position: absolute;
        right: -5px;
        top: 0;
        border-radius: 50%;
        width: 0;
        height: 0;
        opacity: 0;
        background: rgba(255, 220, 0, 1);
        transition: all 0.5s ease 0s;
        z-index: -1;
      }
      .dot-active {
        opacity: 1;
        width: 14px;
        height: 14px;
      }
    }
    .button {
      align-self: center;
      width: 300px;
      height: 42px;
      background: rgba(253, 215, 0, 1);
      border-radius: 28px;
      font-size: 15px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 42px;
    }
  }
  .footer {
    display: flex;
    margin: 20px 0;
    align-self: center;
    font-size: 13px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    text-align: center;
    .read {
      color: rgba(228, 191, 88, 1);
    }
  }
}
</style>
